// extracted by mini-css-extract-plugin
module.exports = {"base":"base--lCvIKG","icon":"icon--km3lcQ","content":"content--ShgNvW"};